export default function getApiHost() {
  if (import.meta.env.MODE === 'production') {
    const firstSubdomain = window.location.hostname.split('.')[0]
    const isLocalhost = window.location.hostname === 'localhost'
    const apiHostName = window.location.hostname.replace(firstSubdomain, 'core')
    return isLocalhost
      ? import.meta.env.VITE_DEV_API_HOST
      : `${window.location.protocol}//${apiHostName}`
  }
  return import.meta.env.VITE_DEV_API_HOST
}
